import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { automationIds } from '../../../constants/automationIds';
import Color from '../../../enums/color';
import Route from '../../../enums/route';
const StyledSpan = styled.span `
  color: ${Color.White};
  height: 32px;
  width: 300px;
  font-family: 'KPMG Web';
  font-size: 40px;
`;
const Logo = () => (<Link to={Route.Home} data-automation-id={automationIds.NAV_LINK.HOME}>
    <StyledSpan>Corporate Tax Manager</StyledSpan>
  </Link>);
export default Logo;
